<template>
  <div class="bg-gray-900">
    <!-- Hero Projects -->
    <div class="relative bg-gray-900 overflow-hidden">
      <div class="hidden sm:block sm:absolute sm:inset-y-0 sm:h-full sm:w-full">
        <div class="relative h-full max-w-screen-xl mx-auto">
          <svg
            class="absolute right-full transform translate-y-1/4 translate-x-1/4 lg:translate-x-1/4"
            width="404"
            height="584"
            fill="none"
            viewBox="0 0 404 784"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x="0"
                y="10"
                width="40"
                height="40"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-800"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="784"
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
        </div>
      </div>

      <div class="relative pt-6 pb-12 sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
        <div class="max-w-screen-xl mx-auto px-4 sm:px-6"></div>

        <main
          class="mt-10 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28"
        >
          <div class="text-center">
            <h2
              class="text-4xl tracking-tight leading-10 font-extrabold text-gray-200 sm:text-5xl sm:leading-none md:text-6xl"
            >
              Octo Digital
              <br class="xl:hidden" />
              <span class="text-red-600">Digital Projects</span>
            </h2>
            <p
              class="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
            >
              This is a showcase of all our Design projects, we provide all our
              customers with design prototypes before building the platforms
              whether its a mobile or web application.
            </p>
            <div
              class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8"
            >
              <div class="rounded-md shadow">
                <a
                  href="/data"
                  class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  <router-link to="/data">Data</router-link>
                </a>
              </div>
              <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
                <a
                  href="/enterprise"
                  class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-black bg-gray-300 hover:text-pink-700 focus:outline-none focus:border-pink-300 focus:shadow-outline-pink transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  <router-link to="/enterprise">Enterprise</router-link>
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <!-- HP end -->
    <div
      class="relative bg-gray-900 pt-10 pb-10 px-4 sm:px-6 lg:pt-10 lg:pb-14 lg:px-8 inline-block"
    >
      <!--Project #1 -->
      <div class="pb-4"> 
      <div class="relative bg-white rounded-lg">
        <div
          class="h-56 bg-gray-900 sm:h-72 lg:absolute lg:left-0 lg:h-full lg:w-1/2"
        >
          <img
            class="w-full h-full object-cover"
            src="@/assets/images/octodigital_esatta.png"
            alt="Esatta | Octo Digital"
          />
        </div>
        <div
          class="relative max-w-screen-xl mx-auto px-4 py-8 sm:py-12 sm:px-6 lg:py-16"
        >
          <div
            class="max-w-2xl mx-auto lg:max-w-none lg:mr-0 lg:ml-auto lg:w-1/2 lg:pl-10"
          >
            <div></div>
            <h2
              class="mt-6 text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
            >
              Fashion application using AR
            </h2>
            <p class="mt-6 text-lg leading-7 text-gray-600">
              Octo Digital was approached by Esatta and En el Instituto de
              Biomecánica to brand, design and build a mobile application
              intergrated with AR. We had also designed and provisioned
              a AWS network architecture with a 99.95% Service Level Agreement.
            </p>
            <div
              class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8"
            >
              <div class="rounded-md shadow">
                <a
                  href="#"
                  class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  Find out more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div> 
      <!-- P1 end -->

      <!--Project #2 -->
      <div class="pb-4"> 
      <div class="relative bg-white rounded-lg">
        <div
          class="h-56 bg-gray-900 sm:h-72 lg:absolute lg:right-0 lg:h-full lg:w-1/2"
        >
          <img
            class="w-full h-full object-cover"
            src="@/assets/images/navigateprostate.png"
            alt="Navigate Prostate | Octo Digital"
          />
        </div>
        <div
          class="relative max-w-screen-xl mx-auto px-4 py-8 sm:py-12 sm:px-6 lg:py-16"
        >
          <div
            class="max-w-2xl mx-auto lg:max-w-none lg:mr-auto lg:ml-1 lg:w-1/2 lg:pr-10"
          >
            <div></div>
            <h2
              class="mt-6 text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
            >
              Navigate - Decision Aid
            </h2>
            <p class="mt-6 text-lg leading-7 text-gray-600">
              We developed a digital patient recruitment strategy and redesigned
              the user experience flow for low-risk prostate cancer patients. We
              successfully reduced cost for digital patient recruitment by 80%.
            </p>
            <div
              class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8"
            >
              <div class="rounded-md shadow">
                <a
                  href="https://news.navigateprostate.com.au/"
                  target="_blank"
                  class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  Information on Prostate Cancer by Navigate
                </a>
              </div>
            </div>
          </div>
        </div>
       </div>
      </div> 
      <!-- P2 end -->
      <!--Project #3 -->
      <div class="pb-4"> <!-- test -->
      <div class="relative bg-white rounded-lg">
        <div
          class="h-56 bg-gray-900 sm:h-72 lg:absolute lg:left-0 lg:h-full lg:w-1/2"
        >
          <img
            class="w-full h-full object-cover "
            src="@/assets/images/spineconsultants.png"
            alt="Spine Consultants | Octo Digital"
          />
        </div>
        <div
          class="relative max-w-screen-xl mx-auto px-4 py-8 sm:py-12 sm:px-6 lg:py-16"
        >
          <div
            class="max-w-2xl mx-auto lg:max-w-none lg:mr-0 lg:ml-auto lg:w-1/2 lg:pl-10"
          >
            <div></div>
            <h2
              class="mt-6 text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
            >
              Spine Consultants
            </h2>
            <p class="mt-6 text-lg leading-7 text-gray-600">
              Octo Digital designed and manage a wordpress site for a Melbourne
              based sports massage therapist during Wave 1 Covid-19, since then
              we have been engaged in delivering a digital strategy for the
              customer.
            </p>
            <div
              class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8"
            >
              <div class="rounded-md shadow">
                <a
                  href="https://spineconsultants.com.au"
                  target="_blank"
                  class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  Spine Consultants
                </a>
              </div>
            </div>
          </div>
        </div>
       </div>
      </div>
      <!-- P3 end -->
      <!--Project #4 -->
      <div class="pb-4"> 
      <div class="relative bg-white rounded-lg">    
        <div
          class="h-56 bg-gray-900 sm:h-72 lg:absolute lg:right-0 lg:h-full lg:w-1/2"
        >
          <img
            class="w-full h-full object-cover"
            src="https://images.unsplash.com/photo-1545987796-200677ee1011?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1280&q=80"
            alt="Network Architecture | Octo Digital"
          />
        </div>
        <div
          class="relative max-w-screen-xl mx-auto px-4 py-8 sm:py-12 sm:px-6 lg:py-16"
        >
          <div
            class="max-w-2xl mx-auto lg:max-w-none lg:mr-auto lg:ml-1 lg:w-1/2 lg:pr-10"
          >
            <div></div>
            <h2
              class="mt-6 text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
            >
              Network Architecture
            </h2>
            <p class="mt-6 text-lg leading-7 text-gray-600">
              Octo Digital has designed and implemented AWS solution
              architecture designs inconjunction with Strategic Rewards for
              employement benefit systems for clients such as NAB life, Myers,
              Coles, Bupa and many others.
            </p>
            <div
              class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8"
            >
              <div class="rounded-md shadow">
                <a
                  class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  <router-link to="/Contact">Contact us</router-link>
                </a>
              </div>
            </div>
          </div>
        </div>
       </div>
      </div>
      <!-- P4 end -->
      <!--Project #5 -->
      <div class="pb-1"> <!-- last project padding different to others -->
      <div class="relative bg-white rounded-lg">
        <div
          class="h-56 bg-gray-900 sm:h-72 lg:absolute lg:left-0 lg:h-full lg:w-1/2"
        >
          <img
            class="w-full h-full object-cover"
            src="https://images.unsplash.com/photo-1485546246426-74dc88dec4d9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1280&q=80"
            alt="Education online | Octo Digital"
          />
        </div>
        <div
          class="relative max-w-screen-xl mx-auto px-4 py-8 sm:py-12 sm:px-6 lg:py-16"
        >
          <div
            class="max-w-2xl mx-auto lg:max-w-none lg:mr-0 lg:ml-auto lg:w-1/2 lg:pl-10"
          >
            <div></div>
            <h2
              class="mt-6 text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
            >
              Designing Education for online
            </h2>
            <p class="mt-6 text-lg leading-7 text-gray-600">
              Octo Digital has partnered with International STEM Education and
              Bridge International Education in providing a digital platform
              allowing the tutoring of small classes with students from private
              schools across Melbourne, and in China.
            </p>
            <div
              class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8"
            >
              <div class="rounded-md shadow">
                <a
                  href="https://www.bridgeinternationaleducation.com/"
                  target="_blank"
                  class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  Bridge International Education
                </a>
              </div>
            </div>
          </div>
        </div>
       </div>
      </div> 
      <!-- P5 end -->
    </div>
    <!-- boxed container end -->
  </div>
</template>
<script>
export default {
  title: "Digital Projects | Octo Digital"
};
</script>
